/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/segments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdSegmentsCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdSegments = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdSegmentsCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/audiences/segments`,
      "PUT",
      {
        segments_ids: props.segments_ids,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
